enum reportsActions {
  CREATE_EMPTY_CASE_REPORT = "CREATE_EMPTY_CASE_REPORT",
  CREATE_EMPTY_SLIDE_REPORT = "CREATE_EMPTY_SLIDE_REPORT",
  GET_OR_FETCH_RESOURCE = "GET_OR_FETCH_RESOURCE",
  SET_SLIDE_OBSERVATIONS = "SET_SLIDE_OBSERVATIONS",
  UPDATE_REPORT = "UPDATE_REPORT",
  PUBLISH_EMPTY_CASE_REPORT = "PUBLISH_EMPTY_CASE_REPORT",
  FETCH_REPORT = "FETCH_REPORT",
  SET_REPORT = "SET_REPORT",
  SET_SLIDE_COMPLETE = "SET_SLIDE_COMPLETE",
  LOAD_OR_CREATE_REPORT = "LOAD_OR_CREATE_REPORT",
  UPDATE_CASE_COMMENTS = "UPDATE_CASE_COMMENTS",
  UPDATE_CASE_COMPLETENESS = "UPDATE_CASE_COMPLETENESS",
  INIT_CASE_OBSERVATIONS = "INIT_CASE_OBSERVATIONS",
  UPDATE_CASE_OBSERVATION = "UPDATE_CASE_OBSERVATION",
  SYNC_WORKFLOWSTATE_AND_IS_COMPLETE = "SYNC_WORKFLOWSTATE_AND_IS_COMPLETE",
  CHECK_FOR_DATA_MISMATCH = "CHECK_FOR_DATA_MISMATCH",
  DELETE_SLIDE_REPORT = "DELETE_SLIDE_REPORT",
}

enum reportsMutations {
  UPDATE_SLIDE_OBSERVATIONS = "UPDATE_SLIDE_OBSERVATIONS",
  SET_SLIDE_WORKFLOW_STATE = "SET_SLIDE_WORKFLOW_STATE",
  SET_ACTIVE_CASE_REPORT_ID = "SET_ACTIVE_CASE_REPORT_ID",
  SET_SLIDE_COMPLETE = "SET_SLIDE_COMPLETE",
  UPDATE_CASE_COMMENTS = "UPDATE_CASE_COMMENTS",
  UPDATE_CASE_COMPLETENESS = "UPDATE_CASE_COMPLETENESS",
  SET_CASE_OBSERVATIONS = "SET_CASE_OBSERVATIONS",
  INIT_CASE_REPORT = "INIT_CASE_REPORT",
  SET_CASE_REPORT = "SET_CASE_REPORT",
  SET_SLIDE_REPORT = "SET_SLIDE_REPORT",
  DELETE_SLIDE_REPORT = "DELETE_SLIDE_REPORT",
}

enum reportsGetters {
  ALL_CASES_REPORTS = "ALL_CASES_REPORTS",
  HAS_CASE_REPORT = "HAS_CASE_REPORT",
  CASE_REPORT = "CASE_REPORT",
  SLIDE_REPORT = "SLIDE_REPORT",
  OBSERVATION = "OBSERVATION",
  SLIDE_OBSERVATIONS = "SLIDE_OBSERVATIONS",
  FILLED_SLIDE_OBSERVATIONS = "FILLED_SLIDE_OBSERVATIONS",
  CASE_COMMENTS = "CASE_COMMENTS",
  SLIDE_COMMENTS = "SLIDE_COMMENTS",
  ACTIVE_REPORT_ID = "ACTIVE_REPORT_ID",
  ACTIVE_CASE_REPORT = "ACTIVE_CASE_REPORT",
  CASE_REPORT_COMPLETE = "CASE_REPORT_COMPLETE",
  COMPLETED_BY = "COMPLETED_BY",
  COMPLETED_ON = "COMPLETED_ON",
}

export { reportsActions, reportsMutations, reportsGetters };
